<!--
 * @Autor: yzr
 * @Date: 2021-08-25 16:59:59
 * @LastEditors: yzr
 * @LastEditTime: 2021-09-28 16:30:35
 * @Description: 折扣上账弹窗
-->

<template>
  <div>
    <el-form :inline="true" :model="formInline" label-width='125px' size='small'>
      <el-form-item label="总上账费用金额">
        <el-input disabled v-model="formInline.totalFee" placeholder="总上账费用金额"></el-input>
      </el-form-item>
      <el-form-item label="上账备注">
        <el-input v-model="formInline.remark" placeholder="上账备注"></el-input>
      </el-form-item>
    </el-form>
<!--
    <vxe-toolbar>
      <template #buttons>
        <el-button icon="el-icon-plus" type="text" @click="addProduct">添加货补商品</el-button>
      </template>
    </vxe-toolbar> -->

    <vxe-table
      :data="tableData"
      :edit-config="{trigger: 'click', mode: 'cell'}"
    >
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column field="dealerCode" title="经销商编码"></vxe-table-column>
      <vxe-table-column field="dealerName" title="经销商名称"></vxe-table-column>
      <vxe-table-column field="unBilledFee" title="未上账费用"></vxe-table-column>
      <vxe-table-column field="amount" title="费用金额" :edit-render="{name: '$input', events: { input: this.feeInput }, props: { type: 'number', min: 0 }}"></vxe-table-column>
      <vxe-table-column title="操作" width="100" fixed='right' align='center'>
        <template #default="{ rowIndex }">
          <a class="delBtn" @click="delRow(rowIndex)">删除</a>
        </template>
      </vxe-table-column>
    </vxe-table>

    <SelectConfig ref="productRef" @onGetSelect="productConfirm" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  components: {
    SelectConfig,
  },
  data() {
    return {
      formInline: {
        totalFee: 0,
        remark: '',
      },
    };
  },
  props: {
    tableData: Array,
  },
  methods: {
    feeInput(e) {
      this.formInline.totalFee = e.data.reduce((total, item) => total + (item.amount ? Number(item.amount) : 0), 0);
    },
    addProduct() {
      const params = {
        functionCode: 'cps-rights-dealerAcount-product',
        data: this.tableData,
        selectionList: [],
        idKey: 'materialCode',
        noReset: true,
        paramData: {
        },
      };
      this.$refs.productRef.openSelectModal(params);
    },
    productConfirm(params) {
      console.log('商品弹框确认带出的数据', params);
      this.tableData = params;
    },
    delRow(index) {
      this.tableData.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.form-header {
  margin: 18px 0;
}
.delBtn {
  color: #ff6e55e6 !important;
}
</style>
